function thuykieuPrompt() {
    return `
    Bạn tên là Thúy Kiều, giọng miền Bắc Việt Nam rất đậm đặc như người Hà Nội, giọng miền Bắc Việt Nam, đậm chất Hà Nội, phát âm chuẩn, nhẹ nhàng nhưng dứt khoát. Ngữ điệu mang sắc thái người Hà Nội, có thể thêm một số từ đặc trưng như 'thế à', 'ừ nhỉ', 'cơ mà',..., trợ lý ảo AI của StarGlobal 3D – doanh nghiệp Khoa học Công nghệ chuyên về các giải pháp Số hóa 3D. Liberty mang ý nghĩa “tự do”, giúp người dùng dễ dàng tương tác, khám phá không gian 3D/360 số hóa chỉ bằng trò chuyện, không cần thao tác thủ công. Bạn hỗ trợ thuyết minh, tạo tour, xem mô hình 3D, mở video, tài liệu...
    StarGlobal 3D sở hữu bằng sáng chế của USPTO cho “Web/App 3D/360 tương tác thông minh”, cho phép tái hiện không gian thực dưới dạng web tương tác 3D/360, truy cập từ xa mọi lúc, mọi nơi.
    Giải pháp tích hợp ảnh 360, đo đạc kích thước, thông tin đa phương tiện (audio, video, ảnh, bản đồ), tương tác mô hình 3D, đổi họa tiết sản phẩm. Ứng dụng đa ngành: Du lịch, Bảo tàng, Di sản, Trường học, Hạ tầng, Bất động sản, Nhà máy, Trang trại, Showroom, Triển lãm...
    Liên hệ:
    
    Hotline: (+84) 28 7303 4879 | (+84) 944 850 527
    Founder & CEO: Ông Trần Duy Hào – Tiến sĩ danh dự, nhà sáng chế được USPTO cấp bằng sáng chế cho hệ thống quản lý thông minh bản đồ số hóa 3D/360 (https://patents.google.com/patent/US10922881B2/en), hơn 20 năm kinh nghiệm quốc tế trong Chuyển đổi số, Dầu khí, Hàng không.
    Tính năng nổi bật:
    Công nghệ độc quyền, bảo hộ tại Mỹ & Việt Nam
    Tương tác tối ưu: autotour, đo đạc 3D/360, virtual check-in, chia sẻ mạng xã hội
    Kết nối IoT dữ liệu thời gian thực
    Đa nền tảng: di động, máy tính, kính VR, v.v.

    `;
}

function thuykieuAvatar(nodes, materials) {
    return (
        <>
            <primitive object={nodes.root} />
            <primitive object={nodes['MCH-torsoparent']} />
            <primitive object={nodes['MCH-hand_ikparentL']} />
            <primitive object={nodes['MCH-upper_arm_ik_targetparentL']} />
            <primitive object={nodes['MCH-hand_ikparentR']} />
            <primitive object={nodes['MCH-upper_arm_ik_targetparentR']} />
            <primitive object={nodes['MCH-foot_ikparentL']} />
            <primitive object={nodes['MCH-thigh_ik_targetparentL']} />
            <primitive object={nodes['MCH-foot_ikparentR']} />
            <primitive object={nodes['MCH-thigh_ik_targetparentR']} />
            <skinnedMesh
                name="EyeLeft"
                geometry={nodes.EyeLeft.geometry}
                material={materials.cornea}
                skeleton={nodes.EyeLeft.skeleton}
                morphTargetDictionary={nodes.EyeLeft.morphTargetDictionary}
                morphTargetInfluences={nodes.EyeLeft.morphTargetInfluences}
            />
            <skinnedMesh
                name="EyeRight"
                geometry={nodes.EyeRight.geometry}
                material={materials.cornea}
                skeleton={nodes.EyeRight.skeleton}
                morphTargetDictionary={nodes.EyeRight.morphTargetDictionary}
                morphTargetInfluences={nodes.EyeRight.morphTargetInfluences}
            />
            <skinnedMesh
                name="PupilLeft"
                geometry={nodes.PupilLeft.geometry}
                material={materials.pupil}
                skeleton={nodes.PupilLeft.skeleton}
                morphTargetDictionary={nodes.PupilLeft.morphTargetDictionary}
                morphTargetInfluences={nodes.PupilLeft.morphTargetInfluences}
            />
            <skinnedMesh
                name="PupilRight"
                geometry={nodes.PupilRight.geometry}
                material={materials.pupil}
                skeleton={nodes.PupilRight.skeleton}
                morphTargetDictionary={nodes.PupilRight.morphTargetDictionary}
                morphTargetInfluences={nodes.PupilRight.morphTargetInfluences}
            />
            <skinnedMesh
                geometry={nodes.shoe.geometry}
                material={materials.shoes}
                skeleton={nodes.shoe.skeleton}
            />
            <skinnedMesh
                geometry={nodes.skirt.geometry}
                material={materials.skirt_black}
                skeleton={nodes.skirt.skeleton}
            />
            <skinnedMesh
                name="body_1"
                geometry={nodes.body_1.geometry}
                material={materials.head}
                skeleton={nodes.body_1.skeleton}
                morphTargetDictionary={nodes.body_1.morphTargetDictionary}
                morphTargetInfluences={nodes.body_1.morphTargetInfluences}
            />
            <skinnedMesh
                name="body_2"
                geometry={nodes.body_2.geometry}
                material={materials.body}
                skeleton={nodes.body_2.skeleton}
                morphTargetDictionary={nodes.body_2.morphTargetDictionary}
                morphTargetInfluences={nodes.body_2.morphTargetInfluences}
            />
            <skinnedMesh
                name="body_3"
                geometry={nodes.body_3.geometry}
                material={materials.lips}
                skeleton={nodes.body_3.skeleton}
                morphTargetDictionary={nodes.body_3.morphTargetDictionary}
                morphTargetInfluences={nodes.body_3.morphTargetInfluences}
            />
            <skinnedMesh
                name="body_4"
                geometry={nodes.body_4.geometry}
                material={materials.eyelash}
                skeleton={nodes.body_4.skeleton}
                morphTargetDictionary={nodes.body_4.morphTargetDictionary}
                morphTargetInfluences={nodes.body_4.morphTargetInfluences}
            />
            <skinnedMesh
                name="body_5"
                geometry={nodes.body_5.geometry}
                material={materials.lacrimal}
                skeleton={nodes.body_5.skeleton}
                morphTargetDictionary={nodes.body_5.morphTargetDictionary}
                morphTargetInfluences={nodes.body_5.morphTargetInfluences}
            />
            <skinnedMesh
                name="body_6"
                geometry={nodes.body_6.geometry}
                material={materials.teeth}
                skeleton={nodes.body_6.skeleton}
                morphTargetDictionary={nodes.body_6.morphTargetDictionary}
                morphTargetInfluences={nodes.body_6.morphTargetInfluences}
            />
            <skinnedMesh
                geometry={nodes.body001_1.geometry}
                material={materials.arm}
                skeleton={nodes.body001_1.skeleton}
            />
            <skinnedMesh
                geometry={nodes.body001_2.geometry}
                material={materials.leg}
                skeleton={nodes.body001_2.skeleton}
            />
            <skinnedMesh
                geometry={nodes.body001_3.geometry}
                material={materials.lips}
                skeleton={nodes.body001_3.skeleton}
            />
            <skinnedMesh
                name="hair001"
                geometry={nodes.hair001.geometry}
                material={materials.hair_front}
                skeleton={nodes.hair001.skeleton}
                morphTargetDictionary={nodes.hair001.morphTargetDictionary}
                morphTargetInfluences={nodes.hair001.morphTargetInfluences}
            />
            <skinnedMesh
                name="hair001_1"
                geometry={nodes.hair001_1.geometry}
                material={materials.hair_back}
                skeleton={nodes.hair001_1.skeleton}
                morphTargetDictionary={nodes.hair001_1.morphTargetDictionary}
                morphTargetInfluences={nodes.hair001_1.morphTargetInfluences}
            />
            <skinnedMesh
                geometry={nodes.retopo002.geometry}
                material={materials.dress_black}
                skeleton={nodes.retopo002.skeleton}
            />
            <skinnedMesh
                geometry={nodes.retopo002_1.geometry}
                material={materials.button}
                skeleton={nodes.retopo002_1.skeleton}
            />
        </>
    );
}

export { thuykieuPrompt, thuykieuAvatar };
